const state = {
  lang: 'en',
  load: false,
  color: 'none',
  navigating: false,
  slider: {
    current: 0,
    isSliding: false,
  },
  menu: {
    open: false,
  },
  page: {
    scrolled: false,
  },
  sound: false,
  bottles: {},
  posts: {},
};

export default state;
